"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    InfoBox: {
      fontFamily: theme['$font-default'],
      fontSize: '12px',
      color: theme['$text-color'],
      borderRadius: 6,
      padding: [7, 10],
      width: '100%',
      boxSizing: 'border-box'
    },
    KindDefault: {
      background: theme['$infobox-background']
    },
    KindPositive: {
      background: theme['$infobox-background-active']
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map